import { request } from "../../utils/config"
import { getRate_mainUSDvsUZS } from "./types/getRate"

export const GET_CURRENCY_RATE = async (): Promise<getRate_mainUSDvsUZS> => {
  const response = await request({
    url: "Helpers/GetMainUSDvsUZS",
  })
  return response.data
}

export const GET_CBU_RATE = async (autoUpdate: boolean = false): Promise<{ rate: number; date: string; diff: string; autoUpdated: boolean }> => {
  const response = await request({
    url: `Helpers/GetCbuExchangeRate?autoUpdate=${autoUpdate}`,
  })
  return response.data
}

